import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

@Component({
    selector: "clare-dialog",
    template: `<mat-icon *ngIf="icon" class="center-text" [svgIcon]="icon">{{ icon }}</mat-icon>
        <h1 mat-dialog-title class="center-text">{{ title }}</h1>
        <ng-container *ngIf="!isLoading; else loadingContent">
            <div mat-dialog-content class="center-text">
                <p id="mainContent">{{ message }}</p>
                <ng-content select="[additionalContent]"></ng-content>
            </div>
            <div mat-dialog-actions class="center-text" *ngIf="!isLoading">
                <ng-content></ng-content>
            </div>
        </ng-container>
        <ng-template #loadingContent>
            <div mat-dialog-content>
                <clare-spinner [text]="loadingMessage"></clare-spinner>
            </div>
        </ng-template>`,
    styles: [
        `
            mat-icon {
                width: 100%;
                height: 48px;
            }
            .center-text {
                text-align: center;
                justify-content: center;
            }
            .mat-dialog-content {
                font-size: 1rem;
                line-height: 1.25rem;
            }
        `,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClareRxDialogComponent {
    @Input() icon: string;
    @Input() title: string;
    @Input() message: string;
    @Input() loadingMessage: string;
    @Input() isLoading: boolean;
}
